/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import PhoneFormatBehavior from '@/behaviors/PhoneFormatBehavior';
import TooltipView from '@/views/TooltipView';

import tmplCACRegistrationInfoForm from './CACRegistrationInfoForm.hbs';

const CACRegistrationInfoForm = View.extend({
  template: tmplCACRegistrationInfoForm,

  className: 'cac-registration-info-form',

  ui: {
    phoneFormat: '.phone-format',
    userNameTooltip: '#userNameTooltip',
    pivTooltip: '#pivTooltip'
  },

  regions: {
    pivTooltip: '@ui.pivTooltip',
    userNameTooltip: '@ui.userNameTooltip'
  },

  behaviors: {
    telephone: PhoneFormatBehavior
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  onRender() {
    this.showChildView(
      'pivTooltip',
      new TooltipView({
        model: new Backbone.Model({
          tooltipText:
            'Enter the 10 digit EDIPI on the back of your CAC card.',
          placement: 'right'
        })
      })
    );

    this.showChildView(
      'userNameTooltip',
      new TooltipView({
        model: new Backbone.Model({
          tooltipText:
            'Do not use your email address. (Example: mgordon , sjones)',
          placement: 'right'
        })
      })
    );
  }
});

export default CACRegistrationInfoForm;
